import { createContext, useState } from 'react';

export const DiamondContext = createContext();

export const DiamondProvider = ({ children }: { children: null | Node }) => {
  const [diamond, setDiamond] = useState(null);

  return (
    <DiamondContext.Provider value={{ diamond, setDiamond }}>
      {children}
    </DiamondContext.Provider>
  );
};
